import 'jquery-match-height';

$(document).ready(function() {
    if (!$('body').hasClass('woocommerce-checkout') && !$('body').hasClass('woocommerce-cart')) {
        return;
    }

    function changeCartItemQty(itemKey, qty) {
        $.ajax({
            url: '/suds/wp-admin/admin-ajax.php',
            type: 'POST',
            data: 'action=update_cart_item&key=' + itemKey + '&qty=' + qty,
            success: function (data) {
                triggerWooCommerceEvent();
            },
            error: function (error) {
                console.log(error);
            }
        });
    }

    function triggerWooCommerceEvent() {
        if ($('body').hasClass('woocommerce-checkout')) {
            $('body').trigger('update_checkout');
        }

        if ($('body').hasClass('woocommerce-cart')) {
            $('body').trigger('wc_update_cart');
        }
    }

    $(document).on('updated_wc_div', 'body',function() {
        $('[data-mh]').matchHeight();
    });

    // basket add extra product
    $(document).on("click", ".js-add-extra-product .btn", function(e) {
        e.preventDefault();
        var $extraProduct = $(".js-add-extra-product");
        var that = $(this);
        var originalText = $(this).html();
        $(this).html("Loading...");

        var productID = $extraProduct.attr("data-product-id");
        var qty = parseInt($extraProduct.find("span.product-quantity").html());

        var data = {
            action: 'add_to_cart_simple_product',
            product: productID,
            quantity: qty
        };

        $.ajax({
            url: '/suds/wp-admin/admin-ajax.php',
            type: 'POST',
            data: data,
            success: function (data) {
                $(that).html(originalText);
                triggerWooCommerceEvent();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR, textStatus, errorThrown);
                $(that).html(originalText);
            }
        });
    });

    $(document).on("click", ".js-dec-product-qty", function (e) {
        e.preventDefault();
        const $input = $(this).parent().find(".product-quantity");
        if ($input) {
            let key = $input.data('item_key');
            let value = parseInt($input.html());
            if (value < 2) {
                value = 2;
            }

            let newValue = value - 1;
            $input.html(newValue);

            if (key) {
                changeCartItemQty(key, newValue);
            }
        }
    });

    $(document).on("click", ".js-inc-product-qty", function (e) {
        e.preventDefault();
        const $input = $(this).parent().find(".product-quantity");
        if ($input) {
            let key = $input.data('item_key');
            const value = parseInt($input.html());

            let newValue = value + 1;
            $input.html(newValue);

            if (key) {
                changeCartItemQty(key, newValue);
            }
        }
    });

    $(document).on("click", ".js-remove-product", function (e) {
        e.preventDefault();
        const itemKey = $(this).data('item_key');
        $.ajax({
            url: '/suds/wp-admin/admin-ajax.php',
            type: 'POST',
            data: 'action=remove_cart_item&key=' + itemKey,
            success: function (data) {
                if (data.cart_item_count === 0) {
                    location.href = '/basket';
                    return;
                }
                triggerWooCommerceEvent();
            },
            error: function (error) {
                console.log(error);
            }
        });
    });

    $(document).on("click", ".js-cart-show-coupon-form", function(e) {
        $('.js-cart-coupon-form').slideToggle(400, function() {
            $('.js-cart-coupon-form').find(':input:eq(0)').trigger('focus');
            $('[data-mh]').matchHeight();
        });
        return false;
    });
});
